(function () {
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 150;

  document.querySelectorAll('.header__inline-menu--showroom').forEach(function (nav) {
    var closeTimer = null;
    var openTimer = null;

    function closeAll(except) {
      nav.querySelectorAll('details.mega-menu--showroom[open]').forEach(function (details) {
        if (details !== except) {
          details.removeAttribute('open');
        }
      });
    }

    function openDetails(details) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        closeAll(details);
        details.setAttribute('open', '');
      }, OPEN_DELAY);
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeAll();
      }, CLOSE_DELAY);
    }

    nav.querySelectorAll('header-menu').forEach(function (headerMenu) {
      var details = headerMenu.querySelector('details.mega-menu--showroom');
      if (!details) return;
      var summary = details.querySelector('summary');

      headerMenu.addEventListener('mouseenter', function () {
        openDetails(details);
      });
      headerMenu.addEventListener('mouseleave', function () {
        scheduleClose();
      });
      summary.addEventListener('focus', function () {
        openDetails(details);
      });
      summary.addEventListener('click', function () {
        clearTimeout(openTimer);
      });
    });

    nav.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });

    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  document.addEventListener('click', function (event) {
    document
      .querySelectorAll('.header__inline-menu--showroom details.mega-menu--showroom[open]')
      .forEach(function (details) {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
  });
})();
